export var TABS_APPEARANCES = {
  default: 'default',
  file: 'file'
};